import React, { useState, useEffect } from 'react';
import { Alert, Snackbar } from '@mui/material';
import axios from 'axios';

const NetworkStatus = () => {
  const [networkError, setNetworkError] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Écouter les changements de connexion
    const handleOnline = () => {
      setIsOnline(true);
      setNetworkError(null);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setNetworkError('Connexion internet perdue');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Intercepteur pour capturer les erreurs réseau
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (!error.response) {
          // Erreur réseau (pas de réponse du serveur)
          setNetworkError('Problème de connexion au serveur. Vérifiez votre connexion internet.');
        } else if (error.response.status >= 500) {
          // Erreur serveur
          setNetworkError('Le serveur rencontre des difficultés. Veuillez réessayer dans quelques instants.');
        } else if (error.response.status === 401) {
          // Erreur d'authentification
          setNetworkError('Session expirée. Vous allez être redirigé vers la page de connexion.');
        }
        
        return Promise.reject(error);
      }
    );

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  const handleClose = () => {
    setNetworkError(null);
  };

  if (!isOnline) {
    return (
      <Snackbar 
        open={true} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" variant="filled">
          🌐 Pas de connexion internet
        </Alert>
      </Snackbar>
    );
  }

  if (networkError) {
    return (
      <Snackbar 
        open={true} 
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="warning" variant="filled" onClose={handleClose}>
          ⚠️ {networkError}
        </Alert>
      </Snackbar>
    );
  }

  return null;
};

export default NetworkStatus; 